import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import type { FlattenSimpleInterpolation } from 'styled-components';
import { simpleMarkdownTransform } from '../../utils/transformers';
import { RichTextComponent } from './RichTextPartial.styles';
import { markdownComponents } from './markdownComponents/MarkdownComponents';

export type RichTextProps = {
  text: string;
  fontSize: FlattenSimpleInterpolation;
  className?: string;
};

export function RichTextPartial({ text, fontSize, className }: RichTextProps) {
  return (
    <RichTextComponent
      components={markdownComponents}
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
      $fontSize={fontSize}
      className={className}
    >
      {simpleMarkdownTransform(text)}
    </RichTextComponent>
  );
}
